
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { GlobalSummaryCheckingAccount } from '@/modules/common/services/graphql/server/server.sdk';
import { RouteMixin } from '@/modules/common/mixins/route';
import { moneyFormat } from '@/modules/common/helpers/currency';
import { GtmTracker } from '@/modules/common/services/analytics';
import {
  CardButtons,
  ActionButtonList
} from '@/modules/common/components/cards/CardButtons';

enum ChoiceInvestmentType {
  Withdrawal = 'withdrawals',
  Deposits = 'deposits'
}

enum ChoiceInvestmentLabel {
  Withdrawal = 'Resgatar',
  Deposits = 'Investir'
}

interface ChoiceInvestment {
  value: ChoiceInvestmentType;
  label: ChoiceInvestmentLabel;
}

@Component({
  components: { CardButtons }
})
export default class CheckingAccountInbox extends mixins(RouteMixin) {
  private module = 'overview';
  title = 'Investimento';
  description = 'Valor não investido';

  button: ActionButtonList[] = [
    { label: 'Investir', action: 'invest' },
    { label: 'Resgatar', action: 'redeem' }
  ];

  @Prop({ type: Object, required: true })
  data!: GlobalSummaryCheckingAccount;

  get formattedMessage() {
    const value = this.data.availableBalance || 0;
    return moneyFormat(Math.abs(value), false);
  }

  get investmentChoices() {
    return {
      WITHDRAWALS: {
        value: ChoiceInvestmentType.Withdrawal,
        label: ChoiceInvestmentLabel.Withdrawal
      },
      DEPOSITS: {
        value: ChoiceInvestmentType.Deposits,
        label: ChoiceInvestmentLabel.Deposits
      }
    };
  }

  availableInvestment(choice: ChoiceInvestment) {
    this.trackEvent(choice.label);
    this.goToTransaction(
      `?choice=${choice.value}&subcontext=dash&module=${this.module}&legacy-investment-account=true`
    );
  }

  private trackEvent(label: ChoiceInvestmentLabel) {
    GtmTracker.trackEvent({
      category: 'Visao Geral',
      action: `Click - Conta Investimento`,
      label
    });
  }
}
